<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="openDialog"
    width="600px"
    center
  >
    <div class="dialog-content">
      <p class="title-money">{{ detailInfo.money }}</p>

      <!-- <div class="bar-status">
        <div class="state-box one">
          <img src="@/assets/images/icon_success.png" />
          <p class="txt-state">申请成功</p>
        </div>
        <i
          class="img-line line-green"
          :class="[detailInfo.state == 100 ? 'line-gary' : 'line-green']"
        ></i>

        <div class="state-box two">
          <img :src="getAuditProgress.imgSrc2" />
          <p class="txt-state">{{ getAuditProgress.txt2 }}</p>
        </div>
        <template v-if="detailInfo.state != 300">
          <i
            class="img-line"
            :class="[detailInfo.state == 100 ? 'line-gary' : 'line-green']"
          ></i>
          <div class="state-box two">
            <img :src="getAuditProgress.imgSrc3" />
            <p class="txt-state">{{ getAuditProgress.txt3 }}</p>
          </div>
        </template>
      </div> -->

      <div class="bill-list">
        <p class="item-wrap">
          <span>税费</span>
          <span>{{ detailInfo.taxe }}</span>
        </p>
        <p class="item-wrap">
          <span>手续费</span>
          <span>{{ detailInfo.service_charge }}</span>
        </p>
        <p class="item-wrap">
          <span>实际到账金额</span>
          <span>{{ detailInfo.real_money }}</span>
        </p>
        <p class="item-wrap">
          <span>到账账号</span>
          <span>{{ detailInfo.acc_id | regroupAcc }}</span>
        </p>
        <!-- <p class="item-wrap">
          <span>到账时间</span>
          <span>{{ detailInfo.date }}</span>
        </p> -->
        <p class="item-wrap">
          <span>订单号</span>
          <span>{{ detailInfo.id }}</span>
        </p>
        <!-- <p class="item-wrap">
          <span>钱包余额</span>
          <span>{{ detailInfo.wallet_num }}</span>
        </p> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'withdrawDetailDialog',
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
    openBillDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDialog: false,
      dialogTitle: '提现金额',
      auditProgress: 0,
      remitProgress: 2,
    };
  },
  computed: {
    getAuditProgress() {
      let auditProgressInfo = {
        imgSrc2: '',
        txt2: '',
        imgSrc3: '',
        txt3: '',
      };
      switch (this.detailInfo.state) {
        case 100:
          auditProgressInfo = {
            imgSrc2: require('@/assets/images/icon_wait.png'),
            txt2: '待审核',
            imgSrc3: require('@/assets/images/icon_wait.png'),
            txt3: '待打款',
          };
          break;
        case 101:
        case 102:
          auditProgressInfo = {
            imgSrc2: require('@/assets/images/icon_success.png'),
            txt2: '审核成功',
            imgSrc3: require('@/assets/images/icon_wait.png'),
            txt3: '待打款',
          };
          break;
        case 200:
          auditProgressInfo = {
            imgSrc2: require('@/assets/images/icon_success.png'),
            txt2: '审核成功',
            imgSrc3: require('@/assets/images/icon_success.png'),
            txt3: '打款成功',
          };
          break;
        case 301:
        case 400:
          auditProgressInfo = {
            imgSrc2: require('@/assets/images/icon_success.png'),
            txt2: '审核成功',
            imgSrc3: require('@/assets/images/icon_failure.png'),
            txt3: '打款失败',
          };
          break;
        case 300:
          auditProgressInfo = {
            imgSrc2: require('@/assets/images/icon_failure.png'),
            txt2: '审核失败',
            imgSrc3: require('@/assets/images/icon_failure.png'),
            txt3: '打款失败',
          };
          break;
      }
      return auditProgressInfo;
    },
    getRemitProgress() {
      let remitProgressInfo = {
        imgSrc: '',
        txt: '',
      };
      switch (this.remitProgress) {
        case 0:
          remitProgressInfo = {
            imgSrc: require('@/assets/images/icon_wait.png'),
            txt: '待打款',
          };
          break;
        case 1:
          remitProgressInfo = {
            imgSrc: require('@/assets/images/icon_success.png'),
            txt: '打款成功',
          };
          break;
        case 2:
          remitProgressInfo = {
            imgSrc: require('@/assets/images/icon_failure.png'),
            txt: '打款失败',
          };
          break;
      }
      return remitProgressInfo;
    },
  },
  filters: {
    regroupAcc(val) {
      if (val) {
        if (typeof val == 'number') {
          return `游戏账号（${val}）`;
        } else {
          let reg1 = /[\u4e00-\u9fa5]{2,}/gi;
          let reg2 = /(\d{1,3})+(?:\.\d+)?/gi;
          let txt1 = val.replace(reg2, '');
          let txt2 = val.replace(reg1, '');
          let res = `${txt1}（${txt2.substring(txt2.length - 4)} ）`;
          return res;
        }
      }
    },
    regroupTime(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      const hours = time.getHours().toString().padStart(2, '0');
      const minute = time.getMinutes().toString().padStart(2, '0');
      const second = time.getSeconds().toString().padStart(2, '0');

      return (
        year +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hours +
        ':' +
        minute +
        ':' +
        second
      );
    },
  },
  watch: {
    openBillDialog(val) {
      this.openDialog = val;
    },
    openDialog(val) {
      if (!val) {
        this.$emit('closeBillDialog', false);
      }
    },
  },
  created() {
    this.openDialog = this.openBillDialog;
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
::v-deep .el-dialog {
  border-radius: 8px;
}
::v-deep .el-dialog__title {
  color: #262626;
  font-size: 14px;
}
::v-deep.el-dialog__body {
  padding: 0 100px 41px;
}
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-money {
    color: $--color-primary;
    font-size: 40px;
  }
  .bar-status {
    margin-top: 26px;
    display: flex;
    .img-line {
      width: 120px;
      height: 2px;
      display: inline-block;
      margin-top: 22px;
    }
    .line-green {
      background: #6bb85b;
    }
    .line-gary {
      background: #b5b5c0;
    }
    .txt-state {
      font-size: 12px;
      color: #81818f;
      margin-top: 4px;
    }
    .state-box {
      width: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .bill-list {
    margin-top: 52px;
    width: 100%;
    .item-wrap {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;
    }
  }
}
</style>
